export const TOP_DESTINATIONS_COLOR_MAP = [
  'blue.200',
  'yellow.900',
  'yellow.200',
  'indigo.100',
  'indigo.400',
];
